/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import AButton from 'components/Antd/Button';
import classes from './Empty.module.scss';

const Empty = ({ className, onAdd }) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <div>
        <span>There is no requirement here.</span>
        <AButton type="primary" size="large" onClick={onAdd}>
          Add Requirement
        </AButton>
        <span className={classes.tips}>
          Tips: Click the “…” button above to apply your saved template and access other
          template-related features.
        </span>
      </div>
    </div>
  );
};

export default Empty;
